import './index.css'
import './Press.css'
import Navbar from './components/Navbar.jsx'
import Footer from './components/Footer.jsx'
import { useEffect } from 'react'

export default function Press(){
    // useEffect(()=>window.scrollTo(0,0),[])
    return (
        <div className='page-wrapper webpage'>
            <div className='webpage-wrapper'>
                <Navbar />

                <main>
                    <h1>Press</h1>

                    <div className='press-flexbox'>
                        <div className='press-left'>

                            <a  href='https://www.theinfatuation.com/new-haven/guides/best-new-haven-restaurants-bars-apizza?ifsb=yes' 
                                target='_blank'>
                            The Best Restaurants in New Haven 2025</a><br/>
                            24 February 2025

                            <br/><br/>

                            <a target='_blank' href='https://www.ctinsider.com/food/article/connecticut-magazine-overall-excellence-2025-20051698.php?utm_content=cta&sid=668845765763f438d1d8c44c&ss=P&st_rid=6a9c906d-afb0-4efa-86b0-ea5a40629bd9&utm_source=newsletter&utm_medium=email&utm_campaign=CT_Taste_Alert'>
                            <span style={{fontStyle:'italic'}}>Connecticut Magazine's</span> top restaurants for 2025</a><br/>
                            Overall Excellence and Best Spanish/Portuguese category<br/>
                            24 January 2025

                            <br/><br/>

                            <a target='_blank' href='https://ctexaminer.com/2024/04/17/dining-at-olea-as-restaurant-week-kicks-off-in-new-haven/'>
                            Dining at Olea, as Restaurant Week Kicks Off in New Haven</a><br/>
                            17 April 2024

                            <br/><br/>

                            <a target='_blank' href='https://www.ctinsider.com/projects/2023/connecticut-magazine-most-romantic-restaurants/'>
                            The 25 Most Romantic Restaurants in Connecticut</a><br/>
                            19 January 2023

                            <br/><br/>

                            <a target='_blank' href='https://www.ctinsider.com/projects/2023/connecticut-magazine-best-restaurants-2023/'>
                            <span style={{fontStyle:'italic'}}>Connecticut Magazine's</span> Best Restaurants 2023<br/></a>
                            19 January 2023

                            <br/><br/>

                            <a target='_blank' href='https://www.wtnh.com/ct-style/ct-style-holidays-in-new-haven-olea/'>
                            CT Style Holidays in New Haven: Olea<br/>
                            </a>
                            30 November 2022

                            <br/><br/>

                            <a target='_blank' href='https://www.infonewhaven.com/who-knew-blog/delicious-thanksgiving-appetizer-get-the-party-started-with-chef-romeros-sharable-app/'>
                                Delicious Holiday Appetizer: Get the Party Started with Chef Romero's Shareable App<br/>
                            </a>
                            16 November 2022

                            <br/><br/>

                            Diners' Choice &mdash; Connecticut / Best Overall Restaurants 2022<br/>
                            OpenTable, November 2022

                            <br/><br/>
                            
                            <a target='_blank' href='https://www.nhregister.com/food_copy_3481_20210610165811/slideshow/connecticut-magazine-best-restaurants-new-haven-232660.php' >
                            The best New Haven-area restaurants for 2022, according to Connecticut Magazine</a><br/>
                            12 March 2022

                            <br/><br/>

                            <a target='_blank' href='https://www.ctinsider.com/connecticutmagazine/food-drink/article/Best-Restaurants-2022-Readers-Choice-winners-17046496.php'>
                            Olea honored for Best Desserts and Best Overall Excellence 
                            in <span style={{fontStyle:'italic'}}>Connecticut Magazine's</span> Best Restaurants 2022: 
                            Experts' Picks and Best Spanish/Portuguese: New Haven County, and Statewide Runner-up: Readers' Choice<br/>
                            </a>
                            29 December 2021

                            <br/><br/>

                            <a target='_blank' href='https://www.ctbites.com/blog/2021/9/30/crazies'>
                            The CRAzies 2021<br/>
                            </a>
                            Connecticut Restaurant Association Awards Gala. Chef of the Year finalist 2021: Manuel Romero

                            <br/><br/>
                            
                            <a target='_blank' href='https://spoonuniversity.com/school/yale/olea-an-elegant-practice-in-modern-spanish-cuisine/'>
                            Olea: An Elegant Practice in Modern Spanish Cuisine    
                            <br/></a>
                            Shirley Wang, Christina Tuttle, and Janie Wu, Spoon University

                            <br/><br/>

                            Olea named #1 Diners' Choice Best Spanish Restaurant in the New York / Tri-State Area<br/>    
                            OpenTable, June 2021

                            <br/><br/>

                            Olea named Best Spanish Restaurant statewide 
                            in <span style={{fontStyle:'italic'}}>Connecticut Magazine's</span> Best Restaurants 2020: Readers' Choice poll<br/>
                            30 December 2019

                            <br/><br/>

                            Olea honored for Best Tapas, Best Desserts, and as a Best Latin American/Spanish Restaurant 
                            in <span style={{fontStyle:'italic'}}>Connecticut Magazine's</span> Best Restaurants 2020: Experts' Picks<br/>
                            30 December 2019

                            <br/><br/>

                            Olea named New Haven County’s Best Spanish restaurant in Connecticut Magazine’s 2019 Readers’ Choice poll
                            <br/>
                            26 December 2018

                            <br/><br/>

                            <a target='_blank' href='https://www.ctbites.com/blog/2018/12/22/rttqfsxon5ke87blhqq9jprtcuuztq?fbclid=IwAR04sBu2La8ZN582GPM-t4opofqbdcY_p1ZfXJBIMG1PRs0Zw6PU3qRwfZI'>
                            Olea named to list of Top 100 Restaurants in Connecticut for 2018 published by CTbites and Hearst Connecticut Media Group
                            </a><br/>
                            23 December 2018

                            <br/><br/>

                            <a target='_blank' href='https://www.nbcconnecticut.com/video/entertainment/ct-live/ct-live-mushroom-velout__hartford/160199/'>
                            Chef Manuel Romero of Olea and Kala Bistro in North Haven made a special guest appearance on CT LIVE!, the lifestyle show of NBC Connecticut.
                            <br/></a>
                            12 December 2018

                            <br/><br/>

                            Chef Manuel Romero Creates a Captivating Culinary Experience<br/>
                            Dana Buckmir, Danalicious Reviews, 5 November 2018

                            <br/><br/>

                            <a target='_blank' href='https://www.thebeveragejournal.com/cra-names-2018-awards-winners-nominees/'>
                            The CRAzies 2018
                            </a><br/>
                            Connecticut Restaurant Association Awards Gala. Chef of the Year finalist 2018: Manuel Romero 

                            <br/><br/>

                            Top 50: New Haven a food destination with something for everyone
                            Mary E. O'Leary, New Haven Register,  28 June 2018

                            <br/><br/>
                            
                            <a target="_blank" href='https://ediblenutmeg.ediblecommunities.com/eat/eat-intimate-cove-intercontinental-fare-olea-kala-bistro/'>
                            An Intimate Cove; An Intercontinental Fare: Olea & Kala Bistro
                            <br/></a>
                            Douglass Steele De Pecol, Edible Nutmeg, 27 March 2018
                            
                            <br/><br/>

                            <a target='_blank' href='https://dailynutmeg.com/blogs/blog/olea-dinner-served'>
                            Dinner Is Served
                            <br/></a>
                            Daily Nutmeg, Sorrel Westbrook, 31 January 2018

                            <br/><br/>

                            Connecticut Magazine Dining Experts Honor Olea as a Best Latin American/Spanish restaurant and for Best Tapas/Small Bites<br/>
                            Best Restaurants 2018: Experts’ Picks, Connecticut Magazine, 27 December 2017

                            <br/><br/>

                            Connecticut Magazine Readers Honor Olea as a Best Spanish Restaurant<br/>
                            Best Restaurants 2018: Readers’ Choice, Connecticut Magazine, 27 December 2017

                            <br/><br/>

                            <a target='_blank' href='https://foodschmooze.org/podcast/party-us-elm-city-party-bike/'>
                            Faith Middleton Food Schmooze: Party with Us on The Elm City Party Bike!
                            <br/></a>
                            19 October 2017

                            <br/><br/>

                            Olea Named #1 Best Overall Connecticut Restaurant among Open Table‘s Diners’ Choice Winners

                            <br/><br/>
                            
                            <a target='_blank' href='https://elizabethkeyser.com/2017/07/30/chefs-tasting-menu-at-olea/'>
                            Chef’s Tasting Menu at Olea
                            <br/></a>
                            — Elizabeth Keyser, 30 July 2017
                            
                            <br/><br/>

                            <a target='_blank' href='https://www.ctbites.com/blog/2017/4/20/10-questions-w-chef-xxxxx-of-olea-in-new-haven'>
                            10 Questions w/ Chef Manuel Romero of Olea in New Haven
                            <br/></a>
                            — Amy Kundrat, CTbites, 7 June 2017

                            <br/><br/>

                            We were honored in four categories in the<br/> 
                            2017 CTNOW Best of New Haven Readers‘ Poll:<br/>
                             - Best Mediterranean Restaurant<br/>
                             - Best Spanish Restaurant<br/>
                             - Best Restaurant for Desserts<br/>
                             - Best Waitperson/Waitservice<br/>

                            <br/><br/>

                            Recent OpenTable awards:<br/>
                             - Best Overall Restaurants in CT<br/>
                             - Best Spanish, New York / Tri-State Area<br/>
                             - Top 10: Best Restaurants That Are Fit for Foodies, New York / Tri-State Area<br/>
                             - Top 10: Best Restaurants for Overall Cuisine in CT<br/>
                             - Top 10: Restaurants with the Best Service in CT<br/>

                            <br/><br/>

                            <a target='_blank' href='https://www.ctinsider.com/connecticutmagazine/food-drink/article/2017-Best-Restaurants-Experts-Picks-17042444.php'>
                            Olea is honored as one of Connecticut‘s Best Latin American/Spanish restaurants and for Best Tapas by Connecticut Magazine
                            <br/></a>
                            — 2017 Best Restaurants: Experts‘ Picks, Connecticut Magazine<br/>
                            5 January 2017

                            <br/><br/>

                            “Chef Romero has an incredible knack of taking familiar Spanish / Mediterranean ingredients and flavors, and translating them into stunning and sophisticated dishes that delight all your senses.“<br/>
                            It’s All In The Details!<br/>
                            — Fairfield County Foodie, 15 December 2016

                            <br/><br/>

                            Chef Romero appears on “Better Connecticut”<br/>
                            — hosted by Scot Haney and Kara Sundlun, “Better Connecticut,” 23 November 2016

                            <br/><br/>

                            Recipe for Olea’s Tomato Gazpacho<br/>
                            — Stephen Fries, New Haven Register, 17 August 2016

                            <br/><br/>

                            Olea named #1 Diners' Choice Best Spanish Restaurant in the New York / Tri-State Area<br/>
                            — OpenTable, June 2016

                            <br/><br/>

                            Olea: Experience authentic Spanish cuisine with an innovative twist<br/>
                            — Dana Buckmir, Danalicious Reviews (formerly posted on examiner.com), 10 May 2016

                            <br/><br/>

                            Recent OpenTable awards:<br/>
                             - Top Ten Best Spanish Restaurants, Diners' Choice, New York / Tri-State Area<br/>
                             - Top Ten Best Overall Restaurants, Diners' Choice, Connecticut<br/>
                             - Top Ten Restaurants with the Best Service, Diners' Choice, Connecticut<br/>

                            <br/><br/>
                            
                            Olea named #1 Diners' Choice Best Spanish Restaurant in the New York / Tri-State Area<br/>
                            — OpenTable, November 2015
                            
                            <br/><br/>

                            25 Best Things to Do in New Haven, Connecticut<br/>
                            — VacationIdea.com, October 2015

                            <br/><br/>

                            <a target='_blank' href='https://www.opentable.com/m/best-restaurants-for-foodies-in-america/'>
                            Olea named one of the 100 Best Restaurants for Foodies in America<br/>
                            </a>
                            — OpenTable, September 2015

                            <br/><br/>

                            "Olea, New Haven"<br/>
                            — Spencer Caldwell, New Haven Living, Hartford Courant, 24 April 2015

                            <br/><br/>

                            <a target='_blank' href='https://yaledailynews.com/blog/2015/03/27/ole-ole-olea/'>
                            "Olé Olé Olea!"<br/>
                            </a>
                            — Grace Castillo, Yale Daily News, 27 March 2015

                            <br/><br/>

                            <a target='_blank' href='https://www.nytimes.com/2015/03/22/nyregion/curtain-rises-on-a-spanish-second-act.html?_r=0'>
                            "Curtain Rises on a Spanish Second Act"<br/>
                            </a>
                            — Sarah Gold, The New York Times, 21 March 2015

                            <br/><br/>
                            
                            <a target='_blank' href='https://www.newhavenindependent.org/index.php/article/at_olea_its_all_about_that_bass'>
                            "At Olea, It’s All About That Bass"<br/>
                            </a>
                            — Lucy Gellman, New Haven Independent, 5 February 2015

                            <br/><br/>

                            "Olea in New Haven Delivers Extraordinary Spanish Dining"<br/>
                            — Elise Maclay, Connecticut Magazine, 27 January 2015

                            <br/><br/>

                            A review from the-e-list<br/>
                            — the-e-list, 20 January 2015

                            <br/><br/>

                            <a target='_blank' href='https://foodschmooze.org/dont-miss-new-havens-olea-restaurant/'>
                            "Don’t Miss New Haven’s Olea Restaurant"<br/>
                            </a>
                            — Faith Middleton's Food Schmooze on WNPR, 10 December 2014

                            <br/><br/>

                            "Try This New Haven Restaurant Week Recipe"<br/>
                            — FoxCT.com, 29 October 2014

                            <br/><br/>

                            "Former Ibiza Chef Opens Sleek Olea in New Haven"<br/>
                            — Linda Giuca, Hartford Courant, 7 October 2014

                            <br/><br/>

                            "New Eats: Olea"<br/>
                            — Liese Klein, New Haven Magazine, pages 58–59, October 2014

                            <br/><br/>

                            "Pictures: Olea in New Haven"<br/>
                            — Patrick Raycraft, ctnow.com, 26 September 2014

                            <br/><br/>

                            <a target='_blank' href='https://chewhaven.wordpress.com/2014/09/04/welcome-back-2014/'>
                            "Welcome Back 2014"<br/>
                            </a>
                            — Chew Haven, 4 September 2014

                            <br/><br/>

                            <a target='_blank' href='https://www.newhavenindependent.org/index.php/article/olea._good_news_for_ibiza_fans'>
                            "Ibiza Becomes 'Olea': Same Chef, New Owner"<br/>
                            </a>
                            — David Sepulveda, New Haven Independent, 3 September 2014

                            <br/><br/>

                            <a target='_blank' href='https://yaledailynews.com/blog/2014/08/28/olea-to-offer-fusion-food-to-students/'>
                            "Olea to Offer Fusion Food to Students"<br/>
                            </a>
                            — J.R. Reed, Yale Daily News, 28 August 2014

                            <br/><br/>



                        </div>{/* .press-left */}    













                        
                        <div className='press-right'>
                            
                            <img src='./2024_DC2-SQUARE-US.webp' />

                            <img src='./dc-2022.webp' />
                            
                            <img src='./open-table-2019.webp' />

                            <a target='_blank' href='https://www.tripadvisor.com/Restaurant_Review-g33851-d7045150-Reviews-Olea-New_Haven_Connecticut.html'>
                                <img    style={{width:'100%'}}
                                        src='./coe-14348-2.png' />
                            </a>

                            <img src='./2018-diners-choice-badge.webp' />

                            <img src='./ctnow-2017.webp' />

                            <img src='./DC_Widget_US_2017_hor.webp' />

                            <a target='_blank' href='https://www.tripadvisor.com/Restaurant_Review-g33851-d7045150-Reviews-Olea-New_Haven_Connecticut.html'>
                                <img    style={{width:'100%'}}
                                        src='./coe-14348-2.png' />
                            </a>

                            <img src='./opentable2016.webp' />

                            <img src='./best-of-new-haven.webp' />

                            <img src='./bca.webp' />

                            <a target='_blank' href='https://www.tripadvisor.com/Restaurant_Review-g33851-d7045150-Reviews-Olea-New_Haven_Connecticut.html'>
                                <img src='./tripadvisor.png' />
                            </a>

                        </div>{/* .press-right */}    
                    </div>{/* .press-flexbox */}
                </main>

                <Footer />            
            </div>{/* .webpage-wrapper */}
        </div>/* .page-wrapper */
    )
}